module.exports = __webpack_public_path__ + "img/foto_1.bf4c3668.jpg";